import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

let sectionCardMap = null;
let resizeObserver = null;
let mutationObserver = null;
let lastInitTime = 0;

console.log("[MAP] Script cargado");

function destroySectionCardMap() {
    console.log("[MAP] Destruyendo mapa...");
    
    if (resizeObserver) {
        try {
            resizeObserver.disconnect();
        } catch (e) {
            console.warn("[MAP] Error desconectando ResizeObserver:", e);
        }
        resizeObserver = null;
    }

    if (sectionCardMap) {
        try {
            sectionCardMap.off();
            sectionCardMap.remove();
        } catch (e) {
            console.warn("[MAP] Error removiendo mapa:", e);
        }
        sectionCardMap = null;
    }

    const mapContainer = document.getElementById('sectioncard-map');
    if (mapContainer) {
        mapContainer.innerHTML = '';
    }
    
    console.log("[MAP] Mapa destruido");
}

function initializeSectionCardMap() {
    const now = Date.now();
    // Evitar reintentos muy rápidos
    if (now - lastInitTime < 300) {
        console.log("[MAP] Reintentos muy rápidos, ignorando");
        return false;
    }
    lastInitTime = now;

    console.log("[MAP] Inicializando mapa...");

    // Limpiar mapa anterior si existe
    if (sectionCardMap) {
        destroySectionCardMap();
    }

    const mapContainer = document.getElementById('sectioncard-map');
    if (!mapContainer) {
        console.error("[MAP] Contenedor no encontrado");
        return false;
    }

    const lat = mapContainer.dataset.lat;
    const lng = mapContainer.dataset.lng;
    const name = mapContainer.dataset.name;
    const accessToken = mapContainer.dataset.accessToken;

    console.log("[MAP] Datos:", { lat, lng, name, token: !!accessToken });

    if (!lat || !lng || !accessToken) {
        console.error("[MAP] Faltan datos");
        return false;
    }

    // Preparar contenedor
    mapContainer.innerHTML = '';
    mapContainer.style.width = '100%';
    mapContainer.style.height = '400px';
    mapContainer.style.minHeight = '400px';
    mapContainer.style.display = 'block';
    mapContainer.style.position = 'relative';

    mapboxgl.accessToken = accessToken;

    try {
        const coords = [parseFloat(lng), parseFloat(lat)];
        console.log("[MAP] Creando mapa en:", coords);

        sectionCardMap = new mapboxgl.Map({
            container: 'sectioncard-map',
            style: 'mapbox://styles/mapbox/streets-v11',
            center: coords,
            zoom: 12
        });

        sectionCardMap.on('load', () => {
            console.log("[MAP] ✓ Mapa cargado");
            
            const popup = new mapboxgl.Popup({ offset: 25 })
                .setHTML(`<strong>${name}</strong>`);

            new mapboxgl.Marker()
                .setLngLat(coords)
                .setPopup(popup)
                .addTo(sectionCardMap);
        });

        sectionCardMap.on('error', (e) => {
            console.error("[MAP] Error:", e);
        });

        if (ResizeObserver) {
            resizeObserver = new ResizeObserver(() => {
                if (sectionCardMap) {
                    try {
                        sectionCardMap.resize();
                    } catch (e) {
                        console.warn("[MAP] Error resize:", e);
                    }
                }
            });
            resizeObserver.observe(mapContainer);
        }

        console.log("[MAP] ✓ Inicializado");
        return true;
    } catch (error) {
        console.error("[MAP] ERROR:", error);
        return false;
    }
}

// Observar cambios en el DOM
function startObservingDOM() {
    console.log("[MAP] Iniciando observación del DOM");
    
    const bodyObserver = new MutationObserver((mutations) => {
        const mapContainer = document.getElementById('sectioncard-map');
        
        if (mapContainer && mapContainer.offsetHeight > 0) {
            // El contenedor es visible y existe
            if (!sectionCardMap) {
                console.log("[MAP] Contenedor visible detectado, inicializando...");
                setTimeout(() => {
                    initializeSectionCardMap();
                }, 150);
            }
        } else if (mapContainer && mapContainer.offsetHeight === 0) {
            // El contenedor existe pero no es visible (modal cerrado)
            if (sectionCardMap) {
                console.log("[MAP] Contenedor oculto, destruyendo mapa...");
                destroySectionCardMap();
            }
        }
    });

    bodyObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
    });

    mutationObserver = bodyObserver;
}

// Iniciar observación
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        console.log("[MAP] DOMContentLoaded");
        startObservingDOM();
    });
} else {
    console.log("[MAP] Documento ya cargado");
    startObservingDOM();
}

// Eventos de Bootstrap como respaldo
document.addEventListener('shown.bs.modal', function (e) {
    console.log("[MAP] shown.bs.modal");
    setTimeout(() => {
        const mapContainer = document.getElementById('sectioncard-map');
        if (mapContainer && !sectionCardMap) {
            initializeSectionCardMap();
        }
    }, 300);
});

document.addEventListener('hidden.bs.modal', function (e) {
    console.log("[MAP] hidden.bs.modal");
    destroySectionCardMap();
});

// Exponer globalmente
window.initializeSectionCardMap = initializeSectionCardMap;
window.destroySectionCardMap = destroySectionCardMap;
